/**
 * Drag and drop ordering of order positions (cart and offer pages).
 * Sub products are never dragged on their own, they follow their parent.
 */
(function ($) {
    'use strict';

    var CONTAINER = '[data-sortable]';
    var ITEM = '[data-order-product-id]';
    var PARENT = '[data-is-sub-product="0"]';

    var detached = null;

    function containers() {
        return $(CONTAINER);
    }

    function parents($container) {
        return $container.children(ITEM).filter(PARENT);
    }

    function groupKey($el) {
        return $el.attr('data-group-key') || '';
    }

    /**
     * Sub products are pulled out for the whole drag, so a position can never be
     * dropped between a parent and its children.
     */
    function detachGroups() {
        var map = {};

        containers().each(function () {
            var $container = $(this);

            $container.children(ITEM).not(PARENT).each(function () {
                var $child = $(this);
                var key = groupKey($child);

                if (!key) {
                    return;
                }

                if (!map[key]) {
                    map[key] = { container: $container, items: $() };
                }

                map[key].items = map[key].items.add($child);
            });
        });

        $.each(map, function (key, entry) {
            entry.items.detach();
        });

        return map;
    }

    /**
     * Children go back by group key, never by DOM adjacency, so a list that has
     * drifted apart is repaired instead of kept broken.
     */
    function reattachGroups(map) {
        if (!map) {
            return;
        }

        $.each(map, function (key, entry) {
            var $parent = entry.container.children(ITEM).filter(PARENT).filter(function () {
                return groupKey($(this)) === key;
            }).first();

            if ($parent.length) {
                $parent.after(entry.items);

                return;
            }

            entry.container.append(entry.items);
        });
    }

    /**
     * The saved order is the truth, so the list is rebuilt from it after every drop.
     * Whatever the widget did on screen, what stays is what the server stored.
     */
    function applySavedOrder(positions) {
        containers().each(function () {
            var $container = $(this);
            var $items = $container.children(ITEM);

            if ($items.length < 2) {
                return;
            }

            var sorted = $items.get().sort(function (a, b) {
                var left = positions[$(a).attr('data-order-product-id')];
                var right = positions[$(b).attr('data-order-product-id')];

                return (left === undefined ? 0 : left) - (right === undefined ? 0 : right);
            });

            // Anything after the positions, such as the gift list, must keep its place.
            var $anchor = $items.first().prev();

            $items.detach();

            if ($anchor.length) {
                $anchor.after(sorted);

                return;
            }

            $container.prepend(sorted);
        });
    }

    function collect() {
        var ids = [];

        containers().each(function () {
            parents($(this)).each(function () {
                ids.push(parseInt($(this).attr('data-order-product-id'), 10));
            });
        });

        return ids;
    }

    function relabel(positions) {
        var counter = 1;
        var prefix = containers().first().attr('data-position-prefix') || '';

        containers().each(function () {
            $(this).children(ITEM).each(function () {
                var id = $(this).attr('data-order-product-id');
                var $label = $(this).find('.js-position-label').first();

                if ($label.length && positions[id] !== undefined) {
                    $label.text(counter + '. (' + prefix + positions[id] + ')');
                }

                counter++;
            });
        });
    }

    function save($container) {
        var all = containers();

        all.sortable('disable');

        $.ajax({
            url: $container.attr('data-reorder-url'),
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            headers: { 'X-CSRF-Token': $('meta[name="csrfToken"]').attr('content') || '' },
            data: JSON.stringify({ ids: collect() })
        }).done(function (response) {
            if (response && response.success) {
                applySavedOrder(response.positions || {});
                relabel(response.positions || {});

                return;
            }

            window.location.reload();
        }).fail(function () {
            window.location.reload();
        }).always(function () {
            all.sortable('enable');
        });
    }

    $(function () {
        if (typeof $.fn.sortable !== 'function') {
            return;
        }

        containers().each(function () {
            var $container = $(this);

            $container.sortable({
                axis: 'y',
                handle: '.js-drag-handle',
                items: '> ' + ITEM + PARENT,
                placeholder: 'position-sortable__placeholder',
                forcePlaceholderSize: true,
                tolerance: 'pointer',
                start: function () {
                    detached = detachGroups();
                    // Row heights changed, the cached drop positions must follow.
                    containers().sortable('refreshPositions');
                },
                stop: function () {
                    reattachGroups(detached);
                    detached = null;
                    save($container);
                }
            });
        });
    });
}(jQuery));
